import { AppFeatures, MessageType } from "@/src/lib/bridge/types";

/**
 * 外链打开的 web / App 分流（EDG-552：换卡、同意文案法务链接、Stripe 门户）。
 *
 * App 内必须走 bridge 交给系统浏览器 —— WebView 里 `window.open` 不可靠，且付款相关页面不应在
 * App WebView 内打开（C-1）。web 侧 `noopener,noreferrer` 防止被打开页反向操纵本页。
 */
export interface OpenExternalEnv {
  isApp: boolean;
  send: (type: MessageType, payload: { url: string }) => void;
}

const isHttpUrl = (url: string): boolean => {
  try {
    const { protocol } = new URL(url);
    return protocol === "https:" || protocol === "http:";
  } catch {
    return false;
  }
};

/** 非 http(s)（含 `javascript:`、空串、相对路径）直接拒绝并返回 false。 */
export function openExternal(url: string, env: OpenExternalEnv): boolean {
  if (!isHttpUrl(url)) {
    return false;
  }
  if (env.isApp) {
    env.send(MessageType.OPEN_URL_EXTERNAL, { url });
    return true;
  }
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}

/** 不在 App 内恒可外跳；App 内仅当原生声明了 `openUrlExternal`（旧版 App 收到消息不执行）。 */
export function canOpenExternal(
  isApp: boolean,
  features: AppFeatures,
): boolean {
  return !isApp || features.openUrlExternal === true;
}
